var Codec = require('io/codec');

var serialiser = {
    read : function(bis) {
        return Codec.readInt32(bis);
    },
    write : function(bos, id) {
        Codec.writeInt32(bos, id);
    }
};

module.exports = serialiser;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/topics/details/topic-id-serialiser.js
// module id = 548
// module chunks = 1